import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { DEFAULT_SEO_PATH } from "utils/constants/paths";

const DefaultSeoPage = Loadable(React.lazy(() => import("./View")));

export const DefaultSeoRoute: IRouteItem = {
  path: DEFAULT_SEO_PATH,
  element: React.createElement(DefaultSeoPage),
  name: "Default SEO",
};
